export type Implantat = {
    id: number;
    namn: string;
};

export const convertImplantatData = ({ implantat }: { implantat: Implantat }) => {
    if (!implantat) {
        return null;
    }

    return {
        value: implantat.id,
        label: implantat.namn,
    };
};
